import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { deleteAccount } from "src/modules/auth/ajax/cloud";
import { getXmppLogin } from "src/modules/auth/duck/selectors";
import { useApp } from "src/components/App/Context";
import Dialog from "src/components/Dialog";
import TextField from "src/components/TextField";
import GenericFailureDialog from "src/components/GenericFailureDialog";
import { getUser } from "src/modules/auth/duck/selectors";
import { BodyText } from "src/atoms/typography";

const log = window.require("electron-log");

export default function DeleteAccountDialog({ onDismiss }) {
  const app = useApp();
  const { t } = useTranslation();
  const { email } = useSelector(getUser);
  const xmppLogin = useSelector(getXmppLogin);
  const [state, setState] = useState({
    password: "",
    error: false,
    isProcessing: false,
    wasDeleted: false,
    allowDelete: false
  });
  const { password, error, isProcessing, wasDeleted, allowDelete } = state;

  function updateState(update) {
    setState((prevState) => ({ ...prevState, ...update }));
  }

  async function handleAccountDelete() {
    if (!password || password === "") return;
    try {
      updateState({ isProcessing: true });
      await deleteAccount({ email, password, xmppLogin });
      updateState({ wasDeleted: true, isProcessing: false });
    } catch (err) {
      log.error(err);
      updateState({ isProcessing: false, error: true });
    }
  }

  return (
    <>
      <GenericFailureDialog
        zIndex={110}
        isOpen={error}
        onDismiss={() => updateState({ error: false })}
      />
      <Dialog
        isOpen={true}
        isProcessing={isProcessing}
        heading={
          !allowDelete
            ? t("account.delete.assurance.heading")
            : !wasDeleted && t("account.delete.heading")
        }
        text={
          !allowDelete
            ? t("account.delete.assurance.text")
            : !wasDeleted && t("account.delete.enterPassword")
        }
        buttons={[
          {
            text: t(wasDeleted ? "buttons.ok" : "buttons.cancel"),
            onClick: wasDeleted ? app.reset : onDismiss
          },
          !wasDeleted && {
            text: t(allowDelete ? "buttons.delete" : "buttons.ok"),
            onClick: allowDelete
              ? async () => await handleAccountDelete()
              : () => updateState({ allowDelete: true })
          }
        ]}
        additionalContent={
          allowDelete && (
            <>
              {wasDeleted ? (
                <Flex justifyContent="center" alignItems="center">
                  <BodyText textAlign="center" color="highEmphasis">
                    {t("account.delete.successfullyDeactivated")}
                  </BodyText>
                </Flex>
              ) : (
                <TextField
                  autoFocus
                  width="296px"
                  value={password}
                  placeholder={t("placeholders.enterPassword")}
                  onChange={({ target }) =>
                    updateState({ password: target.value })
                  }
                  type="password"
                />
              )}
            </>
          )
        }
      />
    </>
  );
}
